// legal.js — central IP / copyright / licence notices for Soloforce Celestia.
// One source of truth so the login screen, app footer and report exports stay
// consistent. Updating ownership wording here updates it everywhere.
//
// © 2026 Soloforce Trading (Pty) Ltd. All rights reserved.

export const COMPANY = "Soloforce Trading (Pty) Ltd";
export const PRODUCT = "Soloforce Celestia";
export const COPYRIGHT_YEAR = 2026;

// Short copyright line — footers, login.
export const COPYRIGHT = `© ${COPYRIGHT_YEAR} ${COMPANY}. All rights reserved.`;

// Full restriction notice — pairs with the copyright line where there is room.
export const RESTRICTION =
  "Unauthorised copying, reproduction, distribution, reverse engineering or commercial use is prohibited.";

// In-app licence summary (limited right to use; no copying / competing product).
export const LICENCE_SUMMARY =
  "Licensed for authorised use only. You receive a limited, non-transferable right to use this software. " +
  "You may not copy, resell, scrape, reverse engineer, or use it to build a competing product. " +
  "The software, workflows and generated templates remain the property of " +
  COMPANY + ". All project data remains confidential.";

// Watermark / footer stamped onto every generated report and PDF export.
export const REPORT_NOTICE =
  `Generated by ${PRODUCT}  ·  © ${COPYRIGHT_YEAR} ${COMPANY}  ·  Confidential and proprietary.`;
